import api from '@/client/core/api'
import { PostDetailResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts/:postId
 */
export async function getTwBenchmarkPostById(
  postId: number,
  groupId: number
): Promise<TwBenchmarkApiResult<PostDetailResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<PostDetailResponse>>(
    `/twitter_benchmark_campaign_posts/${postId}`,
    { params: { groupId } }
  )

  return handleApiResponse<PostDetailResponse>(response)
}
